<template>
  <keep-alive>
    <component :is="pageComponent" :key="locale" @switch-language="switchLanguage" />
  </keep-alive>
</template>

<script>
import TrackingEnglishPage from './TrackingEnglishPage.vue'
import TrackingChinesePage from './TrackingChinesePage.vue'

export default {
  name: 'TrackingApp',
  components: { TrackingEnglishPage, TrackingChinesePage },
  data () {
    return { locale: localStorage.getItem('phoenix-tracking-locale') === 'zh-CN' ? 'zh-CN' : 'en' }
  },
  computed: {
    pageComponent () { return this.locale === 'zh-CN' ? 'TrackingChinesePage' : 'TrackingEnglishPage' }
  },
  methods: {
    switchLanguage () {
      this.locale = this.locale === 'en' ? 'zh-CN' : 'en'
      localStorage.setItem('phoenix-tracking-locale', this.locale)
    }
  }
}
</script>
